export function noop(): void {
  /* noop */
}

export function noopPromise(): Promise<undefined> {
  /* noop */
  return Promise.resolve(undefined)
}
